import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerPage } from '@core/tenant/dealer-site.model';
import { TenantService } from '@core/tenant/tenant.service';
import { Subject, switchMap, takeUntil, of } from 'rxjs';
import { DealerDataService } from '../../dealer-data.service';

@Component({
  selector: 'ade-dealer-page',
  templateUrl: './dealer-page.component.html',
  styleUrls: ['./dealer-page.component.scss'],
})
export class AdeDealerPageComponent implements OnInit, OnDestroy {
  page: DealerPage | null = null;
  pageWidgets: any[] = [];
  notFound = false;

  private _unsub = new Subject<void>();

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _tenantService: TenantService,
    private _svc: DealerDataService,
  ) {}

  ngOnInit(): void {
    this._route.paramMap
      .pipe(
        takeUntil(this._unsub),
        switchMap((params) => {
          const slug = params.get('slug');
          const pages = this._tenantService.profile?.pages ?? [];
          const found = pages.find((p) => p.slug === slug) ?? null;

          if (!found) {
            this.notFound = true;
            this.page = null;
            this.pageWidgets = [];
            return of(null);
          }

          this.notFound = false;
          this.page = found;
          this.pageWidgets = [];

          // Para listings, carrega os widgets da page on-demand
          if (found.pageType === 'listing' && slug) {
            return this._svc.getPage(slug);
          }
          return of(null);
        }),
      )
      .subscribe((r: any) => {
        if (!r) return;
        const items = r?.data;
        const raw = Array.isArray(items) ? items[0] : items;
        this.pageWidgets = raw?.attributes?.content ?? [];
      });
  }

  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }
}
